import { styled } from "@mui/system"
import { Box, Typography } from "@mui/material"

export const DependentWrapperOuter = styled(Box)((props) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "stretch",
  gap: "10px",
}))

export const MessageAndInputWrapper = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  gap: "10px",
}))

export const ValidationMessage = styled(Typography)(() => ({
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  color: "var(--cherry)",
  paddingLeft: "30px",
}))

function validationColor(validationState: string) {
  switch (validationState) {
    case "ok":
      return "var(--green-2)"
    case "error":
      return "var(--cherry)"
    default:
      return "var(--grey-5)"
  }
}

export const LinkWrapper = styled(Box)(
  (props: { validationState: string }) => ({
    display: "flex",
    flexDirection: "column",
    // flex: 1,
    justifyContent: "space-between",
    paddingTop: "30px",
    paddingBottom: "30px",
    width: "20px",
    svg: {
      width: "20px",
      height: "20px",
      color: validationColor(props.validationState),
    },
  }),
)

export const DependentWrapper = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
}))
